module.exports = __webpack_public_path__ + "img/schema_omi_3c.64c778f2.svg";